/** @jsx jsx */
import { jsx } from "theme-ui"
import { useState } from "react"
import PropTypes from "prop-types"
import ReactPlayer from "react-player"

import { ab } from "../theme"

const Video = ({ video, children, reverse, poster }) => {
  const [playing, setPlaying] = useState(false)

  const clickPreviewAction = () => {
    setPlaying(true)
  }

  return (
    <div
      sx={{
        variant: "spacingContainer",
      }}
    >
      <div
        sx={{
          display: ab({ md: "flex" }),
          flexDirection: reverse ? "row-reverse" : "row",
          color: "text",
        }}
      >
        <div
          className="react-player__preview_div"
          sx={{
            flex: 1,
            my: 0,
            py: ab({ md: 3 }),
            paddingRight: ab({ md: reverse ? 0 : 4 }),
            paddingLeft: ab({ md: reverse ? 4 : 0 }),
            ".react-player__preview": {
              minHeight: ab({ _: "250px", md: "330px" }),
              maxHeight: ab({ _: "250px", md: "340px" }),
              backgroundSize: "contain !important",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top center !important",
            },
          }}
        >
          <ReactPlayer
            src={video}
            width="100%"
            height="auto"
            controls={true}
            light={poster}
            playing={playing}
            onClickPreview={clickPreviewAction}
          />
        </div>
        <div
          sx={{
            flex: 1,
            my: 0,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
Video.propTypes = {
  video: PropTypes.string.isRequired,
  children: PropTypes.node,
  reverse: PropTypes.bool,
  poster: PropTypes.string,
}

export default Video
